import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: "Organizarte en 30 minutos y olvidarte del '¿qué cocino hoy?'",
    desc: 'Tendrás un sistema semanal claro, repetible y sin estrés.'
  }, {
    title: 'Entender por qué tu hijo rechaza la comida (y qué hacer en el momento)',
    desc: 'No más improvisación ni culpa. Sabrás exactamente cómo responder.'
  }, {
    title: 'Ofrecer variedad real sin pasarte horas en la cocina',
    desc: '60 recetas que se reutilizan, se congelan y se adaptan a lo que hay en tu heladera.'
  }, {
    title: 'Llevar tu rol con calma y confianza',
    desc: 'Porque cuando tienes claridad, la mesa deja de ser una batalla.'
  }, {
    title: 'Crear hábitos que se sostengan en el tiempo',
    desc: 'No dietas de corto plazo. Hábitos reales, progresivos y posibles.'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-1">
      <div className="max-w-lg md:max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-4">
            LO QUE REALMENTE VAS A LOGRAR
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto rounded-full" data-id="element-5"></div>
        </div>

        <div className="space-y-4" data-id="element-6">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="bg-[#FDFBF7] p-6 rounded-2xl border border-gray-100 shadow-sm flex gap-4 items-start" data-id="element-7">
              <div className="shrink-0 mt-1" data-id="element-8">
                <CheckCircle2 className="w-6 h-6 text-[#4CAF50]" data-id="element-9" />
              </div>
              <div data-id="element-10">
                <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-11">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-12">{benefit.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}